<template>
  <select v-model="internalValue">
    <option
      v-for="(country, code) in countries"
      :key="code"
      :value="code">
      {{ country.name }}
    </option>
  </select>
</template>

<script>

export default {
  name: "CountrySelect",
  props: {
    value: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit(
          "input",
          newVal,
        );
        this.$emit(
          "change",
          newVal,
        );
      },
    },
    countries() {
      return {
        fr: { name: "France" },
        be: { name: "Belgique" },
        lu: { name: "Luxembourg" },
        ch: { name: "Suisse" },
        ca: { name: "Canada" },
        other: { name: "Autre" },
      }
    },
  },
};
</script>
